// Callbacks can't live in redux state (non-serializable), so action-button
// handlers are kept in this module-level registry keyed by toast id.
type ToastActionCallback = () => void;

const registry = new Map<number, ToastActionCallback>();

let nextToastId = 1;

export const generateToastId = (): number => nextToastId++;

export const registerToastAction = (
  id: number,
  callback: ToastActionCallback,
): void => {
  registry.set(id, callback);
};

export const runToastAction = (id: number): void => {
  const callback = registry.get(id);
  registry.delete(id);
  callback?.();
};

export const unregisterToastAction = (id: number): void => {
  registry.delete(id);
};
